<app-modal
  #deleteDocsModal
  [modalMessage]="app.text.pcn.deleteQuestion"
  [modalTitle]="app.text.alert.modalTitle"
  (ok)="deletePcnDocs()"
  >
</app-modal>
<app-paginator
  [length]="app.pcns.pcns.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator>
@if (app.table.selected.size > 0) {
  <div class="row">
    <div class="col-md-4">
      <div class="d-inline-flex selectedAlerts">
        @if (app.table.selected.size > 0) {
          <a
            class="pointer"
            (click)="deleteDocsModal.open()"
            >
            <i class="fas fa-trash"></i> &nbsp;
            {{ app.text.alert.deleteAllSelected }}
          </a>
        }
      </div>
    </div>
    <div class="col-md-4 text-center">
      <div class="text-center d-inline-flex selectedAlerts">
        <span> {{ app.table.selected.size }} {{ app.text.mail.selected }} </span>
        @if (app.table.selected.size !== app.pcns.pcns.length) {
          <a
            class="selectAllButtton"
            (click)="app.table.selectAll(app.pcns.pcns, true)"
            >
            {{ app.text.mail.selectAll }} {{ app.pcns.pcns.length }}
          </a>
        }
        @if (app.table.selected.size === app.pcns.pcns.length) {
          <a
            class="selectAllButtton"
            (click)="app.table.clearSelection()"
            >
            {{ app.text.mail.deselectAll }}
          </a>
        }
      </div>
    </div>
  </div>
}
<div
  class="tableFixHead"
  [ngClass]="{ tableHeight: app.filterTable.isDropdownOpen }"
  >
  <table class="table table-striped spacing-table">
    <thead>
      <tr>
        @for (column of columns; track column) {
          <th class="p-1">
            <div class="d-inline-flex">
              <div
              [ngClass]="{
                'resize-table': app.table.canColumnBeResized(column)
              }"
                >
                <span
                (click)="
                  app.table.toggleSortDirection(column);
                  app.table.sort(app.pcns.pcns)
                "
                  >
                  {{ app.field.handleSpecialLogicLabels(column) }}
                </span>
                @if (column === 'select') {
                  <div>
                    @if (app.table.selected.size === 0) {
                      <i
                        class="far fa-square"
                        (click)="app.table.selectAll(app.pcns.pcns)"
                      ></i>
                    }
                    @if (app.table.selected.size > 0) {
                      <i
                        class="far fa-check-square"
                        (click)="app.table.clearSelection()"
                      ></i>
                    }
                  </div>
                }
              </div>
              &nbsp;
              @if (column === app.table.sortField) {
                <span>
                  @if (app.table.sortDirection === 1) {
                    <i
                      class="fa fa-chevron-up"
                    ></i>
                  }
                  @if (app.table.sortDirection === -1) {
                    <i
                      class="fa fa-chevron-down"
                    ></i>
                  }
                </span>
              }
            </div>
            @if (app.filterTable.getFilterTableColumns(column)) {
              <div>
                <app-filter-table
                  [column]="app.mail.getColumnShort(column)"
                  [columns]="columnsShort"
                  [docType]="'pcn'"
                  [cleanDocs]="app.pcns.cleanPcns"
                  [selectedFilters]="selectedFilters"
                  (resultedDocs)="app.filterTable.getFilterResults($event, 'pcn')"
                  >
                </app-filter-table>
              </div>
            }
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (pcn of app.paginator.getPage(app.pcns.pcns); track pcn) {
        <tr
          class="p-1"
          [ngClass]="{ read: pcn.seen }"
          class="pointer"
          >
          @for (column of columnsShort; track column) {
            <td class="p-1">
              <div>
                @switch (app.table.getColumnTypeDisplay(column)) {
                  @case ('time') {
                    <div
              (click)="
                app.mail.markItemsAsSeen('seen', pcn);
                app.routing.navigatePcn(pcn._id)
              "
                      >
                      {{ pcn[column] | date: "yyyy-MM-dd HH:mm:ss" }}
                    </div>
                  }
                  @case ('date') {
                    <div
              (click)="
                app.mail.markItemsAsSeen('seen', pcn);
                app.routing.navigatePcn(pcn._id)
              "
                      >
                      @if (pcn[column] > 0) {
                        <span>
                          {{ pcn[column] | date: "yyyy-MM-dd" : "UTC" }}
                        </span>
                      }
                    </div>
                  }
                  @case ('normal') {
                    <div
              (click)="
                app.mail.markItemsAsSeen('seen', pcn);
                app.routing.navigatePcn(pcn._id)
              "
                      >
                      {{ pcn[column] }}
                    </div>
                  }
                  @case ('artNumber') {
                    <div
                      (click)="navigateTo('artNumber', pcn[column])"
                      >
                      {{ pcn[column] }}
                    </div>
                  }
                  @case ('navigateAction') {
                    <div
                      (click)="navigateTo('crtNumber', pcn['crtNumber'], pcn['artNumber'])"
                      >
                      {{ pcn[column] }}
                    </div>
                  }
                  @case ('actions') {
                    <div>
                      @if (column === 'createCase') {
                        <div >
                          <i
                            class="far fa-folder-plus click-area icon-blue pointer"
                  (click)="
                    app.routing.navigateNewThread();
                    app.pcn.id = pcn._id;
                    app.pcn.pcn = app.pcn.getPcn(pcn._id)
                  "
                          ></i>
                        </div>
                      }
                      @if (column === 'seen') {
                        <div>
                          @if (
                            pcn[column] &&
                            pcn.update_user !== undefined &&
                            pcn.update_time !== null
                            ) {
                            <button
                              class="btn btn-hidden pt-0 ps-0"
                  [ngbTooltip]="
                    pcn.update_user +
                    ' ' +
                    app.text.credits.on +
                    ' ' +
                    (pcn.update_time | date: 'yyyy-MM-dd')
                  "
                              >
                              <i class="fas fa-check-double fa-green"></i>
                            </button>
                          }
                          @if (pcn[column] && pcn.update_user == undefined) {
                            <button
                              class="btn btn-hidden pt-0 ps-0"
                              >
                              <i class="fas fa-check-double fa-green"></i>
                            </button>
                          }
                          @if (!pcn[column]) {
                            <button class="btn btn-hidden pt-0 ps-0">
                              <i class="fas fa-exclamation-circle fa-orange"></i>
                            </button>
                          }
                        </div>
                      }
                      @if (column === 'select') {
                        <div>
                          @if (!pcn[column]) {
                            <button
                              class="btn btn-hidden pt-0 ps-0"
                  (click)="
                    app.table.toggleSelect(pcn); $event.stopPropagation()
                  "
                              >
                              @if (app.table.selected.has(pcn)) {
                                <i
                                  class="far fa-check-square"
                                ></i>
                              }
                              @if (!app.table.selected.has(pcn)) {
                                <i
                                  class="far fa-square"
                                ></i>
                              }
                            </button>
                          }
                        </div>
                      }
                    </div>
                  }
                  @case ('getFieldValueAsText') {
                    <div
              (click)="
                app.mail.markItemsAsSeen('seen', pcn);
                app.routing.navigatePcn(pcn._id)
              "
                      >
                      {{ app.field.getFieldValueAsText("pcn." + column, pcn[column]) }}
                    </div>
                  }
                  @case ('optionText') {
                    <div
              (click)="
                app.mail.markItemsAsSeen('seen', pcn);
                app.routing.navigatePcn(pcn._id)
              "
                      >
                      <span
                        class="badge badgeStatus"
                [ngStyle]="
                  app.field.getColor(
                    app.fieldId.alert.criticality,
                    pcn.criticality
                  )
                "
                        >
                        {{ app.field.getOptionText("pcn." + column, pcn[column]) }}
                      </span>
                    </div>
                  }
                  @case ('limit') {
                    <div
                      class="fixedWidth"
              (click)="
                app.mail.markItemsAsSeen('seen', pcn);
                app.routing.navigatePcn(pcn._id)
              "
                      >
                      <span (click)="$event.stopPropagation()">
                        <app-limit
                  [textInput]="
                    app.field.getItemsAsString(
                      app.field.getFieldValueAsArray(
                        'pcn.' + column,
                        pcn[column]
                      )
                    )
                  "
                          limit="20"
                          >
                        </app-limit>
                      </span>
                    </div>
                  }
                }
              </div>
            </td>
          }
        </tr>
      }
      <tr>
        @if (loading) {
          <td colspan="99" class="text-center">
            {{ this.app.text.core.loading }}
          </td>
        }
        @if (!loading && app.pcns.pcns.length === 0) {
          <td
            colspan="99"
            class="text-center"
            >
            {{ app.text.app.noResults }}
          </td>
        }
      </tr>
    </tbody>
  </table>
</div>
<app-paginator
  [length]="app.pcns.pcns.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator>
